import React from "react";
import { BrowserRouter, HashRouter, Route, Switch } from "react-router-dom";
import LoginCallback from "./LoginCallback";

export const isPublicDashboardHost = () =>
  [
    "dashboard.enhancedif.org",
    "dashboard.eifdata.org",
    "dashboard.eifhub.test.ecritportfolio.org",
  ].includes(window.location.hostname.toLowerCase());

const AppRouter = ({ children, login }) => {
  // Check if this is an OAuth callback URL
  const isOAuthCallback = window.location.pathname === "/auth/callback";

  if (isOAuthCallback) {
    // Use BrowserRouter for OAuth callback
    return (
      <BrowserRouter>
        <Switch>
          <Route
            path="/auth/callback"
            render={() => <LoginCallback onLoginSuccess={login} />}
          />
        </Switch>
      </BrowserRouter>
    );
  }

  if (isPublicDashboardHost()) {
    return <BrowserRouter>{children}</BrowserRouter>;
  }

  // Use HashRouter for all other routes
  return <HashRouter>{children}</HashRouter>;
};

export default AppRouter;
